
import { defineComponent } from 'vue';
import api from '@/api/api';
import { store } from '@/store';
import { M_MENU } from '@/store/mutations-types';
import { columns } from '@/utils/columns';
import { formsValidations } from '@/utils/formsValidations';
import { formatKm } from '@/utils/formatkm';
import Grid from '@/components/Grid.vue';
import ModalCrud from '@/components/ModalCrud.vue';

export default defineComponent({
	name: 'ManutencaoCarrosView',
	components: {
		Grid,
		ModalCrud
	},
	data() {
		return {
			origins: [],
			table: {
				isLoading: false,
				dataset: [],
				gridItemsActions: [
					{
						label: 'Lançar Km',
						action: 'lancarKm',
						icon: 'mdi-counter',
						color: 'primary',
						display: true,
						loading: false
					},
					{
						label: 'Detalhes',
						action: 'detalhes',
						icon: 'mdi-chevron-right',
						color: 'primary',
						display: true,
						loading: false
					}
				]
			},
			modals: {
				filtrarCarros: {
					data: {
						form: {
							carros: [],
							pendencias: [],
						},
						inputs: {
							carros: [],
							pendencias: [
								{
									id: 'km',
									label: 'Km sem lançar'
								},
								{
									id: 'manutencao',
									label: 'Manutenção pendente'
								},
								{
									id: 'vencida',
									label: 'Manutenção vencida'
								},
								{
									id: 'solicitacao',
									label: 'Solicitação pendente'
								},
								{
									id: 'ok',
									label: 'Sem pendência'
								},
							],
						}
					},
					isLoading: false,
					title: 'Filtrar',
					visible: false,
				},
				lancarKm: {
					isLoading: false,
					visible: false,
					title: '',
					idCarro: 0,
				},
				pendencias: {
					visible: false,
					item: {
						carro: '',
						placa: '',
                        numero: '',
						kmPendente: false,
						itensPendentesManutencao: [],
						solicitacoesEmAberto: 0,
						solicitacoesAguardando: 0
					}
				}
			},
			forms: {
				lancarKm: {
					data: {
						kmAtual: null,
						dataExecucao: '',
					},
					controls: {
						isValid: true,
					}
				}
			}
		}
	},
	methods: {
		loadOrigins: async function () {
			try {
				const { data } = await api.get('/cars-maintenance-origins');
				this.origins = data;
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			}
		},
		iconFor: function (codigo) {
			return this.origins.find(x => x.codigo === codigo)?.icone ?? 'mdi-wrench';
		},
		detalheKmData: function (km, data) {
			return [
				km ? `Km: ${formatKm(km)}` : null,
				data ? `Data: ${data}` : null
			].filter(Boolean).join(' ');
		},
		textoProximaManutencao: function (descricao, km, data) {
			const detalhe = this.detalheKmData(km, data);

			return detalhe ? `${descricao} - ${detalhe}` : descricao;
		},
		loadData: async function () {
			try {
				this.modals.filtrarCarros.visible = false;
				this.table.isLoading = true;

				const { data } = await api.get('/cars-maintenance/cars', {
					params: {
						carros: this.modals.filtrarCarros.data.form.carros,
						pendencias: this.modals.filtrarCarros.data.form.pendencias,
					}
				});

				this.table.dataset = data;
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			} finally {
				this.table.isLoading = false;
			}
		},
		handleFilter: async function () {
			try {
				this.modals.filtrarCarros.isLoading = true;
				this.modals.filtrarCarros.visible = true;

				const { data } = await api.get('/cars-maintenance/filter-cars');

				this.modals.filtrarCarros.data.inputs.carros = data ?? [];
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			} finally {
				this.modals.filtrarCarros.isLoading = false;
			}
		},
		destroyFilter: function () {
			this.modals.filtrarCarros.visible = false;
			this.modals.filtrarCarros.data.inputs.carros = [];
		},
		handleXlsxExport: async function () {
			try {
				const { XlsxExport } = await import('@/utils/xlsxExport');

				const prepareData = this.table.dataset.map(x => {
					const proximaManutencao = x.proximaManutencaoDescricao
						? this.textoProximaManutencao(x.proximaManutencaoDescricao, x.proximaManutencaoKm, x.proximaManutencaoData)
						: '';

					const pendencias = [
						x.kmPendente ? 'Km sem lançar' : null,
						x.solicitacoesEmAberto ? `Solicitação em aberto (${x.solicitacoesEmAberto})` : null,
						x.solicitacoesAguardando ? `Solicitação aguardando manutenção (${x.solicitacoesAguardando})` : null,
						...x.itensPendentesManutencao.map(i => `${i.descricao}${i.vencida ? ' (vencida)' : ''}`)
					].filter(Boolean).join(' | ');

					return {
						NUMERO: x.numero,
						PLACA: x.placa,
						CARRO: x.carro,
						KM_ATUAL: x.kmAtual ?? '',
						PROXIMA_MANUTENCAO: proximaManutencao,
						PENDENCIAS: pendencias,
					};
				});

				let instanceExport = new XlsxExport({
					columns: [
						{
							label: "Num.",
							name: "NUMERO",
						},
						{
							label: "Placa",
							name: "PLACA",
						},
						{
							label: "Carro",
							name: "CARRO",
						},
						{
							label: "Km Atual",
							name: "KM_ATUAL",
						},
						{
							label: "Próx. Manutenção",
							name: "PROXIMA_MANUTENCAO",
						},
						{
							label: "Pendências",
							name: "PENDENCIAS",
						},
					],
					data: prepareData,
					title: `Manutenção Carros`
				});

				await instanceExport.export();
				instanceExport = null;
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao exportar!');
			}
		},
		showModalLancarKm: function (item) {
			this.modals.lancarKm.idCarro = item.id;
			this.modals.lancarKm.title = `Lançar Km — ${item.numero} ${item.carro} (${item.placa})`;
			this.modals.lancarKm.visible = true;
			this.forms.lancarKm.data = { kmAtual: null, dataExecucao: '' };
		},
		saveLancarKm: async function () {
			try {
				if (this.$refs.form.validate()) {
					this.modals.lancarKm.isLoading = true;

					await api.post('/cars-maintenance-km', {
						...this.forms.lancarKm.data,
						idCarro: this.modals.lancarKm.idCarro
					});

					this.$toast.success('Km lançado com sucesso!');
					this.modals.lancarKm.visible = false;
					await this.loadData();
				} else {
					this.$toast.warning('Formulário inválido! Verifique os dados.');
				}
			} catch (error) {
				this.$toast.error(error?.message ?? 'Falha ao comunicar com o banco de dados!');
			} finally {
				this.modals.lancarKm.isLoading = false;
			}
		},
		totalPendencias(item) {
			return (item.kmPendente ? 1 : 0)
				+ item.itensPendentesManutencao.length
				+ (item.solicitacoesEmAberto > 0 ? 1 : 0)
				+ (item.solicitacoesAguardando > 0 ? 1 : 0);
		},
		severidadeColor(item) {
			return item.itensPendentesManutencao.some(x => x.vencida) ? 'red' : 'amber darken-2';
		},
		abrirPendencias(item) {
			this.modals.pendencias.item = item;
			this.modals.pendencias.visible = true;
		},
		handleGridItemsActions: function (action: 'lancarKm' | 'detalhes', item) {
			switch (action) {
				case 'lancarKm':
					this.showModalLancarKm(item);
					break;
				case 'detalhes':
					this.$router.push(`/cars-maintenance/${item.id}`);
					break;
				default:
					this.$toast.error('Opção de ação inválida!');
			};
		},
	},
	computed: {
		totais() {
			return {
				carrosComPendencia: this.table.dataset.filter(x => this.totalPendencias(x) > 0).length,
				vencidas: this.table.dataset.filter(x => x.itensPendentesManutencao.some(i => i.vencida)).length,
				kmPendente: this.table.dataset.filter(x => x.kmPendente).length,
			}
		},
	},
	async mounted() {
		store.commit(M_MENU, "Manutenção Carros");
		await this.loadOrigins();
		await this.loadData();
	},
	setup() {
		return {
			columns,
			formsValidations,
			formatKm
		}
	}
})
